import type { HubFaq, HubSection } from "@/components/HubEditorial";

/**
 * Suomenkielinen sisältö (/fi). Kirjoitettu suomeksi — ei konekäännös.
 * Kalix sijaitsee noin 40 minuutin ajomatkan päässä Torniosta ja
 * Haaparannasta, joten suuri osa asiakkaistamme tulee Suomen puolelta.
 */

/* ---------------------------------- /fi ----------------------------------- */

export const fiHubSections: HubSection[] = [
  {
    h2: "Miksi ostaa asuntoauto Ruotsista?",
    paragraphs: [
      "Kalix on Torniosta noin 90 kilometriä eli reilun tunnin ajomatka, ja Haaparannasta pääset meille alle tunnissa. Moni suomalainen asiakas tulee meille siksi, että Ruotsin käytettyjen asuntoautojen markkina on selvästi suurempi kuin Suomessa: valikoima on laajempi ja hintataso usein maltillisempi, erityisesti isommissa integroiduissa malleissa ja Rapidon kaltaisissa merkeissä.",
      "Palvelemme suomeksi. Voit soittaa, laittaa sähköpostia tai tulla paikan päälle ja hoitaa koko kaupan suomeksi — myös paperit käydään läpi rauhassa niin, että tiedät tarkalleen mitä maahantuonti Suomeen edellyttää.",
      "Kaikki myymämme ajoneuvot ovat kosteusmitattuja ja kaasulaitteiltaan tarkastettuja luovutuksessa. Se ei ole lisämaksullinen palvelu vaan kuuluu kauppaan, koska kosteusvaurio on ainoa vika, joka voi tehdä käytetystä asuntoautosta taloudellisesti kannattamattoman.",
    ],
    bullets: [
      "Kalix – Tornio noin 90 km, Kalix – Haaparanta noin 60 km.",
      "Palvelu suomeksi puhelimessa, sähköpostilla ja paikan päällä.",
      "Jokainen ajoneuvo kosteusmitattu ja kaasutarkastettu luovutuksessa.",
    ],
  },
  {
    h2: "Näin tuonti Suomeen käytännössä menee",
    paragraphs: [
      "Ruotsista ostettu ajoneuvo siirretään Suomeen normaalina EU-sisäkauppana. Käytännön järjestys on: kauppakirja ja luovutus meillä Kalixissa, ajoneuvon poisto Ruotsin rekisteristä (avställning/export), siirto Suomeen sekä Suomessa autoveroilmoitus Verohallinnolle ja rekisteröintikatsastus Traficomin hyväksymässä katsastustoimipaikassa.",
      "Autovero on se erä, joka kannattaa laskea etukäteen. Verohallinnon autoverolaskuri antaa suuntaa-antavan arvion, kun tiedät ajoneuvon merkin, mallin, käyttöönottopäivän, kokonaismassan ja päästöluvun. Autoveron määrä riippuu ajoneuvon yleisestä verotusarvosta Suomessa — eli siitä, mitä vastaava auto Suomessa maksaa — ei siitä, mitä maksoit meille.",
      "Yli 4 500 kg kokonaismassan asuntoautoista ei Suomessa peritä autoveroa. Tämä on syy, jonka takia moni suomalainen ostaja päätyy meillä juuri raskaampaan runkoon: kokonaiskustannus voi olla pienempi kuin kevyemmässä autossa, vaikka ostohinta olisi korkeampi. Muista kuitenkin, että yli 3 500 kg vaatii C1- tai C-luokan ajokortin.",
    ],
    bullets: [
      "Kauppakirja ja luovutus Kalixissa — käymme paperit läpi suomeksi.",
      "Ruotsin rekisteristä poisto ennen siirtoa; hoidamme oman osuutemme.",
      "Autoveroilmoitus Suomessa ennen käyttöönottoa, sitten rekisteröintikatsastus.",
      "Yli 4 500 kg asuntoauto on Suomessa autoverovapaa — mutta vaatii C1/C-kortin.",
    ],
  },
  {
    h2: "Siirtoluvat, vakuutus ja kilvet",
    paragraphs: [
      "Ajoneuvo pitää saada laillisesti Kalixista Suomen puolelle. Käytännössä vaihtoehtoja on kolme: ruotsalaiset koenumerokilvet siirtoon rajalle, suomalainen siirtolupa Traficomilta tai kuljetus lavetilla. Lyhyellä matkalla Kalix–Tornio siirtolupa on tavallisin ja edullisin ratkaisu.",
      "Vakuutus on otettava voimaan ennen kuin ajoneuvo liikkuu. Suomalainen liikennevakuutus voidaan kirjoittaa siirtoluvalle, ja se on halvempaa hoitaa etukäteen kuin rajalla. Tarkista myös, että vakuutus kattaa ajoneuvon myös silloin kun se seisoo katsastusta odottamassa.",
      "Me emme jätä sinua yksin tähän vaiheeseen. Kerromme mitä papereita sinun kannattaa olla mukana ottamassa, ja voimme sopia luovutusajan niin, että ehdit hoitaa siirron saman päivän aikana.",
    ],
    bullets: [
      "Siirtolupa Traficomilta on lyhyellä matkalla yleensä edullisin tapa.",
      "Liikennevakuutus voimaan ennen ajoa — hoida se etukäteen, ei rajalla.",
      "Lavettikuljetus kannattaa isoissa ja rekisteristä poistetuissa ajoneuvoissa.",
    ],
  },
  {
    h2: "Mitä kannattaa tarkistaa ennen kauppaa",
    paragraphs: [
      "Käytetyn asuntoauton kunto ratkeaa neljässä kohdassa: kosteus, kaasu, alusta ja huoltohistoria. Kosteus mitataan mittarilla katsaikkunoiden karmeista, kaappien takaseinistä ja lattiakulmista. Alle 15 prosentin lukema on kuiva, 15–20 prosenttia on seurattava ja yli 20 prosenttia tarkoittaa aina lisäselvitystä.",
      "Kaasulaitteiston letkuissa on päivämäärämerkintä, ja letkut vaihdetaan noin 5–8 vuoden välein. Säätimen tulee olla asennettuna törmäyssuojattuna, ja kaasuvaroittimen kuuluu istua matalalla, koska nestekaasu on ilmaa raskaampaa.",
      "Alustasta katsotaan ruoste erityisesti takarungosta, jousipaketeista ja vetokoukun kiinnityksestä. Pohjoisen suolatuilla teillä tämä on olennaisempaa kuin etelämpänä. Huoltokirjasta tarkistetaan jakohihna, jäähdytysneste ja jarrunesteen vaihtovälit — moottoripuoli on tavallinen pakettiauton alusta, joten varaosat ja huolto ovat Suomessa helppoja.",
    ],
    bullets: [
      "Kosteusmittaus: alle 15 % kuiva, yli 20 % vaatii aina lisäselvityksen.",
      "Kaasuletkujen päivämäärä ja säätimen törmäyssuoja tarkistetaan aina.",
      "Kantavuus: monessa autossa on vain 300–500 kg kuormaa jäljellä.",
    ],
  },
];

export const fiHubFaq: HubFaq[] = [
  {
    q: "Palveletteko suomeksi?",
    a: "Kyllä. Voit hoitaa koko kaupan suomeksi puhelimitse, sähköpostilla tai paikan päällä Kalixissa. Soita 070-862 97 43 (Ruotsista) tai +46 70 862 97 43 Suomesta.",
  },
  {
    q: "Kuinka pitkä matka Torniosta on liikkeeseenne?",
    a: "Kalix on Torniosta noin 90 kilometriä eli runsas tunti E4-tietä. Haaparannasta matkaa on noin 60 kilometriä.",
  },
  {
    q: "Paljonko autovero maksaa Suomessa?",
    a: "Autovero määräytyy ajoneuvon yleisen verotusarvon eli Suomen markkinahinnan mukaan, ei ostohinnan mukaan. Verohallinnon autoverolaskurilla saat suuntaa-antavan arvion, kun tiedät merkin, mallin, käyttöönottopäivän ja päästöluvun. Yli 4 500 kg kokonaismassan asuntoautot ovat autoverottomia.",
  },
  {
    q: "Voinko maksaa euroissa?",
    a: "Sovimme maksutavasta aina tapauskohtaisesti. Kauppahinta on kruunuissa, mutta euromaksu pankkisiirtona onnistuu — kysy tarjousta niin katsotaan kurssi ja käytännön järjestely yhdessä.",
  },
  {
    q: "Miten saan ajoneuvon Suomeen?",
    a: "Tavallisimmin suomalaisella siirtoluvalla ja voimassa olevalla liikennevakuutuksella, tai ruotsalaisilla koenumerokilvillä rajalle. Lavettikuljetus on vaihtoehto isoille ajoneuvoille. Kerromme luovutuksen yhteydessä, mikä sinun tapauksessasi on järkevintä.",
  },
  {
    q: "Onko ajoneuvoilla takuu?",
    a: "Käymme jokaisen ajoneuvon kunnon läpi rehellisesti ennen kauppaa ja kerromme myös puutteet. Takuun sisältö sovitaan ajoneuvokohtaisesti ikä ja ajokilometrit huomioiden — kysy aina kyseisen auton kohdalla.",
  },
  {
    q: "Otatteko vaihdossa vanhan asuntoauton tai -vaunun?",
    a: "Otamme. Lähetä kuvat, malli, vuosimalli ja mittarilukema niin annamme vaihtoarvion. Suomirekisterinen ajoneuvo käy myös vaihdossa.",
  },
  {
    q: "Mikä ajokortti riittää?",
    a: "B-kortilla saa ajaa enintään 3 500 kg kokonaismassan ajoneuvoa. Sitä raskaammat vaativat C1-kortin (enintään 7 500 kg) tai C-kortin. Yli 4 500 kg on Suomessa autoverovapaa, joten ajokorttiluokka kannattaa miettiä ennen mallivalintaa.",
  },
];

/* ---------------------------- /fi/asuntoautot ------------------------------ */

export const fiAutotSections: HubSection[] = [
  {
    h2: "Millainen asuntoauto sopii pohjoiseen?",
    paragraphs: [
      "Pohjoisen olosuhteissa merkitsevät eristys, lämmitys ja vesijärjestelmän sijoitus. Talvikäyttöön tarkoitetussa autossa vesitankit ja putket ovat lämmitetyssä tilassa, ei ulkopuolella. Jos suunnittelet käyttöä huhtikuun ulkopuolella, kysy aina onko auto talvitestattu ja miten viemäriventtiilit on suojattu.",
      "Lämmitysratkaisuja on kaksi tavallista: nestekaasulämmitin kiertoilmalla tai dieselkäyttöinen lämmitin. Diesel on käytössä edullisempi pitkillä pakkasjaksoilla, koska et ole riippuvainen kaasupullojen vaihdosta -25 asteessa. Nestekaasu taas on hiljaisempi ja yksinkertaisempi huoltaa.",
      "Pohjaratkaisussa kannattaa miettiä oikeasti käyttöä. Kaksi henkilöä pärjää lyhyellä autolla ja poikittaisella takasängyllä; perhe tarvitsee kerrossängyt tai nostosängyn. Yli 7-metrinen auto on Norrbottenin pikkuteillä ja monella leirintäalueella hankalampi kuin miltä paperilla näyttää.",
    ],
    bullets: [
      "Talvikäyttö: tankit ja putket lämmitetyssä tilassa, ei ulkona.",
      "Dieselämmitin on pitkillä pakkasjaksoilla huolettomampi kuin kaasu.",
      "Pituus 6–7 m on paras kompromissi tilan ja liikuteltavuuden välillä.",
    ],
  },
  {
    h2: "Puoli-integroitu, integroitu vai retkeilyauto?",
    paragraphs: [
      "Puoli-integroitu (halvintegrerad) on yleisin: ohjaamo on alkuperäinen pakettiauton ohjaamo ja asuintila rakennettu sen taakse. Se on edullisin, kevein ja helpoin korjata. Integroidussa (helintegrerad) koko keula on valmistajan rakentama, mikä antaa paremman eristyksen ja tilan tunteen sekä usein laskeutuvan sängyn ohjaamon yläpuolelle.",
      "Retkeilyauto eli kastenwagen on pakettiauton rungossa, tyypillisesti 5,4–6,4 metriä. Se mahtuu normaaliin parkkiruutuun ja toimii myös arkiautona, mutta säilytystila ja vesitankit ovat pienemmät. Jos teet paljon lyhyitä reissuja ja ajat itse kaupungissa, tämä on usein järkevin valinta.",
      "Alkovi on hinnaltaan edullisin tapa saada monta vuodepaikkaa. Vastineeksi tulee korkeampi ilmanvastus, hieman suurempi kulutus ja tuulisella tiellä herkempi ohjaustuntuma.",
    ],
    bullets: [
      "Puoli-integroitu: edullisin ja helpoin huoltaa — yleisin valinta.",
      "Integroitu: paras eristys ja tilantuntu, kallein hankinta.",
      "Retkeilyauto: mahtuu parkkiruutuun, vähemmän säilytystilaa.",
      "Alkovi: eniten vuodepaikkoja hinnalla mitattuna.",
    ],
  },
  {
    h2: "Mitä käytetty asuntoauto maksaa",
    paragraphs: [
      "Hintataso jakautuu karkeasti näin: 10–15 vuotta vanha puoli-integroitu 250 000–450 000 kruunua, 5–10 vuotta vanha 450 000–750 000 kruunua ja lähes uusi integroitu yli miljoonan. Arvon aleneminen on jyrkintä ensimmäisen kolmen vuoden aikana, minkä jälkeen käyrä loivenee selvästi.",
      "Käytännössä 4–7 vuotta vanha auto on paras ostohetki: pahin arvonalennus on jo tapahtunut, mutta tekniikka on vielä nykyaikaista ja huolto edullista. Muista laskea myös Suomen autovero mukaan kokonaishintaan, kun vertaat suomalaisiin ilmoituksiin.",
      "Ajokilometrit merkitsevät asuntoautossa vähemmän kuin henkilöautossa. 150 000 kilometriä ajanut, hyvin huollettu ja kuiva auto on parempi ostos kuin 60 000 kilometriä ajanut, kosteusvaurioitunut auto. Runko ratkaisee, ei mittarilukema.",
    ],
    bullets: [
      "Paras ostoikkuna: 4–7 vuotta vanha auto.",
      "Laske Suomen autovero mukaan, kun vertaat suomalaisiin hintoihin.",
      "Kuiva runko on tärkeämpi kuin matala mittarilukema.",
    ],
  },
];

export const fiAutotFaq: HubFaq[] = [
  {
    q: "Näkyvätkö kaikki asuntoautot verkkosivuilla?",
    a: "Kyllä, koko varastomme päivittyy sivulle automaattisesti. Jos etsit tiettyä mallia jota ei juuri nyt ole, soita — meille tulee jatkuvasti vaihtoautoja, ja voimme myös etsiä sinulle sopivan.",
  },
  {
    q: "Voinko koeajaa?",
    a: "Voit. Sovi aika etukäteen puhelimitse, niin auto on valmiina ja ehdimme käydä sen läpi rauhassa. Myös ilta- ja viikonloppuajat onnistuvat.",
  },
  {
    q: "Onko autoissa tehty kosteusmittaus?",
    a: "Jokainen luovuttamamme ajoneuvo on kosteusmitattu ja kaasulaitteistoltaan tarkastettu. Näytämme mittaustulokset sinulle ennen kauppaa.",
  },
  {
    q: "Millainen kantavuus asuntoautossa on?",
    a: "Tyypillisesti 300–500 kg kuormaa täydellä varustuksella. Kaksi henkilöä, täysi vesitankki, polkupyörät ja grilli syövät sen nopeasti. Punnitse auto kuormattuna ennen pitkää matkaa.",
  },
  {
    q: "Sopiiko asuntoauto talvikäyttöön?",
    a: "Talvitestattu auto sopii. Tarkista että vesitankit ja putket ovat lämmitetyssä tilassa ja että lämmityskapasiteetti riittää -25 asteeseen. Kysy meiltä mallikohtaisesti — kaikki mallit eivät ole talvikäyttöisiä.",
  },
];

/* ---------------------------- /fi/asuntovaunut ----------------------------- */

export const fiVaunutSections: HubSection[] = [
  {
    h2: "Asuntovaunu vai asuntoauto?",
    paragraphs: [
      "Asuntovaunu on halvempi hankkia ja pitää: saat samalla rahalla selvästi enemmän asuintilaa, eikä sinulla ole toista moottoria huollettavana. Kun vaunu on paikallaan leirintäalueella, vetoauto jää vapaaksi päiväretkiä varten — tämä on suurin käytännön ero asuntoautoon.",
      "Vastineeksi liikkuvuus kärsii. Vaunun kytkeminen, peruuttaminen ja ahtailla teillä ajaminen vaativat harjoittelua, ja talvisäilytys vie tilaa. Jos vaihdat paikkaa joka toinen päivä, asuntoauto on käytännöllisempi. Jos olet samalla alueella viikon tai enemmän, vaunu voittaa lähes aina.",
      "Ajokorttisääntö kannattaa tarkistaa ennen ostoa. B-kortilla vetoauton ja vaunun yhteenlaskettu kokonaismassa saa olla enintään 3 500 kg. B/E-kortti eli BE-luokka nostaa rajan olennaisesti, ja se on Suomessa suhteellisen nopea suorittaa.",
    ],
    bullets: [
      "Sama raha ostaa vaunussa selvästi enemmän neliöitä.",
      "Vetoauto jää käyttöön leiripaikalla — vaunun suurin etu.",
      "Tarkista ajokorttiluokka: B-kortin yhdistelmäraja on 3 500 kg.",
    ],
  },
  {
    h2: "Vetokyky ja turvallinen yhdistelmä",
    paragraphs: [
      "Nyrkkisääntö on, että vaunun todellinen paino ei saisi ylittää 85 prosenttia vetoauton omamassasta, jos haluat vakaan yhdistelmän maantienopeudessa. Tekninen vetokyky rekisteriotteessa on maksimi, ei tavoite. Sivutuulessa ja ohitustilanteessa marginaali ratkaisee.",
      "Kuorman sijoittelu on toinen puoli turvallisuutta. Painavat tavarat akselin päälle ja matalalle, kevyet päihin. Liian kevyt aisapaino tekee vaunusta heiluvan; liian raskas keventää vetoauton etuakselia ja huonontaa ohjautuvuutta. Tavoittele valmistajan ilmoittamaa aisapainoa, tyypillisesti 50–100 kg.",
      "Vakautusjärjestelmä eli heilahduksenvaimennin vetopäässä ja mahdollinen elektroninen vakautus vaunun akselilla ovat halpaa turvallisuutta. Renkaat vanhenevat vaunussa nopeammin kuin kuluvat — yli kuusi vuotta vanhat renkaat kannattaa vaihtaa vaikka pinta näyttäisi hyvältä.",
    ],
    bullets: [
      "85 %:n sääntö vetoauton omamassasta antaa vakaan yhdistelmän.",
      "Aisapaino tyypillisesti 50–100 kg — älä ali- tai ylikuormaa vetopäätä.",
      "Vaihda yli kuusi vuotta vanhat renkaat kuviosta riippumatta.",
    ],
  },
  {
    h2: "Kosteus on vaunun tärkein tarkistuskohde",
    paragraphs: [
      "Asuntovaunun rakenne on kevyempi kuin asuntoauton, ja saumat sekä kattoluukkujen karmit ovat tavallisin vuotokohta. Mittaa kosteus aina takakulmista, sängyn alta, kaapiston takaseinistä ja lattiakulmasta oven vierestä. Yli 20 prosentin lukema tarkoittaa, että rakenne on kastunut jossain vaiheessa.",
      "Katso myös silmällä: aaltoileva seinäpinta, tummunut vaneri kaapin sisällä, pehmeä lattia ja tuore silikoni saumassa ovat merkkejä, joita ei kannata ohittaa. Tuore silikoni ilman huoltopaperia on aina kysymys, ei vastaus.",
      "Kaikki meiltä lähtevät vaunut on kosteusmitattu ja kaasutarkastettu luovutuksessa, ja käymme mittaustulokset läpi kanssasi. Suosittelemme oman kosteustarkastuksen tekemistä joka syksy myös oston jälkeen.",
    ],
    bullets: [
      "Mittaa: takakulmat, sängyn alta, kaapiston takaa, lattiakulma ovella.",
      "Aaltoileva seinä tai pehmeä lattia = kastunut rakenne, ei kosmetiikkaa.",
      "Tarkista kattoluukkujen ja ikkunoiden saumat joka syksy.",
    ],
  },
];

export const fiVaunutFaq: HubFaq[] = [
  {
    q: "Voinko vetää asuntovaunua B-kortilla?",
    a: "Voit, jos vetoauton ja vaunun yhteenlaskettu kokonaismassa on enintään 3 500 kg. Suuremmat yhdistelmät vaativat BE-luokan kortin.",
  },
  {
    q: "Onko käytetty vaunu järkevä hankinta?",
    a: "On, jos runko on kuiva. Vaunun arvo laskee hitaammin kuin asuntoauton ja hyvin hoidettu 10-vuotias vaunu voi palvella vielä toiset 10 vuotta.",
  },
  {
    q: "Miten vaunu talvisäilytetään?",
    a: "Kuivaan tilaan, tuuletus päällä, kosteudenpoistaja sisään ja renkaiden paine tarkistettuna. Tyhjennä vesijärjestelmä kokonaan ja jätä hanat auki.",
  },
  {
    q: "Saako vaunun rekisteröityä Suomeen samalla tavalla kuin auton?",
    a: "Kyllä, prosessi on vastaava: poisto Ruotsin rekisteristä, siirto, autoveroilmoitus ja rekisteröintikatsastus Suomessa. Perävaunun verotus poikkeaa autosta, joten tarkista ajankohtainen tilanne Verohallinnolta.",
  },
];

/* -------------------------------- /fi/rapido ------------------------------- */

export const fiRapidoSections: HubSection[] = [
  {
    h2: "Rapido — ranskalaista rakennuslaatua",
    paragraphs: [
      "Rapido on ranskalainen valmistaja vuodelta 1961, ja se on rakentanut maineensa runkolaadulla eikä markkinoinnilla. Keskeinen ero moneen kilpailijaan on runkorakenne: puuton sandwich-rakenne, jossa seinä- ja lattiaelementeissä ei ole puuta kantavana materiaalina. Käytännössä tämä tarkoittaa, että kosteuden päästessä rakenteeseen se ei mätäne samalla tavalla kuin puurunkoisessa autossa.",
      "Tämä näkyy jälleenmyyntiarvossa. Kymmenen vuoden ikäinen Rapido pitää arvonsa selvästi paremmin kuin useimmat massavalmisteiset kilpailijat, ja käytettynä ostettuna se on siksi usein kokonaistaloudellisesti edullisempi vaikka ostohinta olisi korkeampi.",
      "Olemme erikoistuneet Rapidoon ja pidämme myös varaosia. Jos etsit tiettyä mallia tai vuosimallia, kerro se meille — meille tulee säännöllisesti vaihdossa Rapidoja, joita ei ehdi ilmoituksiin asti.",
    ],
    bullets: [
      "Puuton sandwich-runko — ei lahoa kosteudesta samalla tavalla.",
      "Hyvä jälleenmyyntiarvo pitkällä aikavälillä.",
      "Meiltä myös Rapidon varaosat ja mallikohtainen neuvonta.",
    ],
  },
  {
    h2: "Mallisarjat lyhyesti",
    paragraphs: [
      "C-sarja on kompakti puoli-integroitu, tyypillisesti 6–7 metriä, ja sopii pariskunnalle joka haluaa liikkuvuutta. M-sarja on laadukkaampi puoli-integroitu, jossa on parempi eristys ja korkeampi varustelutaso. Serie 8 ja Serie 9 ovat integroituja malleja, joissa keula on Rapidon oma ja tilantuntu selvästi suurempi.",
      "Distinction on mallisto huipulla: integroitu, korkea varustelu ja rakenne, joka kestää ympärivuotista käyttöä. Se on myös painavin, ja monissa versioissa kokonaismassa ylittää 3 500 kg — mikä tarkoittaa C1-korttia mutta voi Suomessa tuoda autoveroetua yli 4 500 kg painoluokassa.",
      "Vuosimalli merkitsee Rapidossa erityisesti alustan osalta: uudemmat mallit ovat Fiat Ducaton uudemmalla rungolla, jossa on parempi ajettavuus ja modernit turvavarusteet. Kerromme aina mallikohtaisesti mitä juuri kyseisessä yksilössä on.",
    ],
    bullets: [
      "C-sarja: kompakti, liikkuva, pariskunnalle.",
      "M-sarja: parempi eristys ja varustelu, edelleen puoli-integroitu.",
      "Serie 8 / Serie 9: integroitu, iso tilantuntu.",
      "Distinction: huippumalli, ympärivuotinen käyttö, painavin.",
    ],
  },
];

export const fiRapidoFaq: HubFaq[] = [
  {
    q: "Saako Rapidon varaosia Suomeen?",
    a: "Saa. Pidämme varaosia ja voimme tilata mallikohtaisia osia. Kerro malli, vuosimalli ja mieluiten valmistenumero, niin löydämme oikean osan.",
  },
  {
    q: "Miksi Rapido on kalliimpi kuin moni kilpailija?",
    a: "Runkorakenne ja materiaalit ovat kalliimpia valmistaa. Vastineeksi arvon aleneminen on hitaampaa, joten omistusajan kokonaiskustannus on usein pienempi.",
  },
  {
    q: "Onko Rapido hyvä talvikäyttöön?",
    a: "Ylemmät mallistot ovat, erityisesti Distinction ja monet Serie 8/9 -versiot. Tarkista aina mallikohtaisesti lämmitysteho ja tankkien sijoitus.",
  },
];

/* ----------------------------- /fi/yhteystiedot ---------------------------- */

export const fiKontaktSections: HubSection[] = [
  {
    h2: "Näin löydät meille Suomesta",
    paragraphs: [
      "Osoitteemme on Stabsvägen 5, 952 51 Kalix. Torniosta ajat E4-tietä Haaparannan kautta noin 90 kilometriä, aikaa kuluu runsas tunti. Kemistä matkaa on noin 115 kilometriä ja Oulusta noin 215 kilometriä, eli Oulusta päivän reissu onnistuu hyvin.",
      "Rajan ylitys Tornio–Haaparanta on sujuva eikä vaadi erillisiä toimenpiteitä. Muista aikaero: Ruotsissa kello on tunnin jäljessä Suomen ajasta, joten sovi tapaamisaika aina selkeästi kumman maan ajassa.",
      "Aukioloaikamme ovat sopimuksen mukaan. Se ei tarkoita vaikeaa — se tarkoittaa, että soitat ja me järjestämme ajan, myös iltaisin ja viikonloppuisin. Näin varmistamme, että olemme paikalla ja auto on valmiina kun tulet pitkän matkan takaa.",
    ],
    bullets: [
      "Stabsvägen 5, 952 51 Kalix, Ruotsi.",
      "Tornio noin 90 km, Kemi noin 115 km, Oulu noin 215 km.",
      "Ruotsin aika on tunnin Suomen aikaa jäljessä — sovi aika selkeästi.",
    ],
  },
  {
    h2: "Mitä ota mukaan käynnille",
    paragraphs: [
      "Ota mukaan henkilöllisyystodistus, ajokortti ja tieto siitä, mikä ajokorttiluokka sinulla on. Jos harkitset vaihtoa, ota mukaan nykyisen ajoneuvosi rekisteriote ja huoltokirja sekä kuvia — silloin voimme antaa vaihtoarvion samalla käynnillä.",
      "Jos rahoitus on ajankohtainen, kerro se etukäteen puhelimessa. Ruotsalainen rahoitus suomalaiselle ostajalle ei aina onnistu suoraviivaisesti, joten on parempi selvittää tilanne ennen matkaa kuin paikan päällä.",
      "Varaa käynnille aikaa vähintään tunti. Käymme läpi kosteusmittauksen, kaasulaitteet, huoltohistorian ja koeajon rauhassa. Jos tulet Oulun suunnalta, kannattaa varata koko päivä.",
    ],
    bullets: [
      "Henkilöllisyystodistus ja ajokortti mukaan.",
      "Vaihtoajoneuvosta rekisteriote, huoltokirja ja kuvat.",
      "Kerro rahoitustarpeesta etukäteen puhelimessa.",
    ],
  },
];

export const fiKontaktFaq: HubFaq[] = [
  {
    q: "Mihin numeroon soitan Suomesta?",
    a: "Soita +46 70 862 97 43. Myyjämme Aaron vastaa ja palvelemme suomeksi.",
  },
  {
    q: "Voinko varata katsomisajan etukäteen?",
    a: "Kyllä, ja se kannattaa. Soita tai laita sähköpostia osoitteeseen info@akhusbilfritid.se, niin sovitaan aika joka sopii sinulle — myös illat ja viikonloput käyvät.",
  },
  {
    q: "Kuinka nopeasti vastaatte sähköpostiin?",
    a: "Vastaamme yleensä saman päivän aikana, viimeistään 24 tunnin sisällä.",
  },
];
